import { render, staticRenderFns } from "./Payments.vue?vue&type=template&id=b61d2c6c&scoped=true"
import script from "./Payments.vue?vue&type=script&lang=js"
export * from "./Payments.vue?vue&type=script&lang=js"
import style0 from "./Payments.vue?vue&type=style&index=0&id=b61d2c6c&prod&scoped=true&lang=css"
import style1 from "./Payments.vue?vue&type=style&index=1&id=b61d2c6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b61d2c6c",
  null
  
)

export default component.exports